import Table from '@components/table'
import Button from '@components/button'
import Svg from '@components/svg'
import Image from '@components/image'
import Typography from '@components/typography'
import Column from '@components/column'
import Row from '@components/row'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { User } from '@apis'
import { Formik } from 'formik'
import Fields from '@components/fields'
import TableActions from '@components/table/actions'
import debounce from '@utils/debounce'
const ActiveInstitutions = () => {
  const navigate = useNavigate()
  const { items: institutions } = useSelector(
    (state: any) => state.activeInstitutions,
  )
  const [params, setParams] = useState<any>({
    page: 1,
    limit: 10,
    role: 'institution',
    isApproved: true,
    search: '',
  })
  const columns = [
    {
      key: 'name',
      title: 'Name',
      render: (item) => {
        return (
          <Row alignItems="center" colGap={10}>
            <Image
              src={`${process.env.BUCKET_URL}/${item?.avatar}`}
              width={40}
              height={40}
              styleImage={`border-radius:50%;`}
            />
            <Column rowGap={2}>
              <Typography content={item?.name} size={12} />
              <Typography content={item?.phoneNo} size={12} tc="placeholder" />
              <Typography content={item?.email} size={12} tc="placeholder" />
            </Column>
          </Row>
        )
      },
    },
    {
      key: 'type',
      title: 'Institution Type',
      render: (item: any) => {
        return item?.infos?.instituteType
      },
    },
    {
      key: 'address',
      title: 'Address',
      render: (item: any) => {
        return item?.infos?.address
      },
    },
    {
      key: 'phoneNo',
      title: 'Mobile No',
    },
    {
      key: 'status',
      title: 'Active Status',
      render: (item) => {
        return (
          <Formik
            initialValues={{
              isActive: item?.isActive,
            }}
            onSubmit={() => {}}
          >
            {() => {
              return (
                <Fields.Switch
                  name="isActive"
                  onChange={async (value) => {
                    await User.updateStatus({
                      state: 'activeDoctors',
                      id: item?.id,
                      action: 'update',
                      data: {
                        isActive: value,
                      },
                    })
                  }}
                />
              )
            }}
          </Formik>
        )
      },
    },
    {
      key: 'actions',
      title: 'Actions',
      render: (item) => {
        return (
          <TableActions
            onClickView={() => {
              navigate(`/admin/institutions/details/${item?.id}`, {
                state: item,
              })
            }}
            hasDelete={false}
            hasEdit={false}
          />
        )
      },
    },
  ]
  const fetchInstitutions = async (params) => {
    await User.list({
      params: params,
      state: 'activeInstitutions',
    }).catch(() => {})
  }

  const handleSearch = debounce(async (event: any) => {
    const text = event.target.value
    const updateParams = {
      ...params,
      search: text,
    }
    await fetchInstitutions(updateParams)
    setParams(updateParams)
  }, 500)

  useEffect(() => {
    if (!institutions?.length) {
      fetchInstitutions(params)
    }
  }, [])
  return (
    <Table
      columns={columns}
      data={institutions}
      filter={{
        hasSearch: true,
        onSearch: handleSearch,
        rightComponent: (
          <>
            <Button
              title="Add Institution"
              leftComponent={<Svg svg="plus" color={'white'} />}
              height={40}
              onClick={() => {
                navigate('/admin/institutions/create')
              }}
            />
          </>
        ),
      }}
    />
  )
}

export default ActiveInstitutions
